import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { utils, styles } from 'gipsy-misc'
import { headerPaddingStyle } from 'features/list/styles'

import RescheduleOverloadButton from 'features/todolist/components/rescheduleOverloadButton'

const propTypes = {
  group: PropTypes.string,
  totalDuration: PropTypes.number,
  onClick: PropTypes.func,
  rightText: PropTypes.string,
  shouldReschedule: PropTypes.bool,
  noCapitalize: PropTypes.bool
}

class ListHeader extends PureComponent {
  render() {
    const { group, totalDuration, onClick, shouldReschedule, rightText, noCapitalize } = this.props

    if (typeof totalDuration === 'undefined') {
      return (
        <Header className="list-header" noCapitalize={noCapitalize} group={group}>
          <h1>{group}</h1>
          {rightText && (
            <RightComponent onClick={onClick} group={group}>
              {rightText}
            </RightComponent>
          )}
        </Header>
      )
    }
    const style = shouldReschedule ? { color: styles.colors.pinkColor, marginRight: styles.spacings.xsmall } : {}
    return (
      <Header className="list-header" noCapitalize={noCapitalize} group={group}>
        <h1>{group}</h1>
        <RightComponent style={style} group={group}>
          {shouldReschedule && <RescheduleOverloadButton />}
          <div>{utils.datetime.beautifyDuration(totalDuration)}</div>
        </RightComponent>
      </Header>
    )
  }
}

ListHeader.propTypes = propTypes

export default ListHeader

const Header = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${headerPaddingStyle}
  h1 {
    margin-bottom: 30px !important;
  }
  ${({ noCapitalize }) =>
    noCapitalize &&
    css`
      h1 {
        text-transform: none !important;
      }
    `}
  ${props =>
    props.group === 'updates' &&
    css`
      border-bottom: 1px solid ${styles.colors.lightGrey};
      padding-bottom: 12px;
      &&& h1 {
        font-size: ${styles.fonts.fontSize};
        color: ${styles.colors.textLightColor};
        margin-bottom: 0px !important;
      }
    `}
`

const RightComponent = styled.div`
  padding-right: 10px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  font-weight: 500;
  font-size: ${styles.fonts.fontSizeSmall};
  flex-shrink: 0;
  ${props =>
    props.onClick &&
    css`
      cursor: pointer;
    `}
  ${props =>
    props.group === 'updates' &&
    css`
      font-size: ${styles.fonts.fontSizeXSmall};
      color: ${styles.colors.textLightColor};
      font-weight: 500;
    `}
`



// WEBPACK FOOTER //
// ./src/features/list/components/listHeader/index.js